module.exports = __webpack_public_path__ + "static/media/vnda16.f98a733d.png";